import { render, staticRenderFns } from "./XInputGroupCategories.vue?vue&type=template&id=5d1a810e"
import script from "./XInputGroupCategories.vue?vue&type=script&lang=js"
export * from "./XInputGroupCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports